/**
 * Configurator: Vorhangschiene nach Mass (Curtain Rails)
 *
 * Sections:
 *   1. Helpers
 *   2. Config  — read data attributes set by configurator-schiene.liquid
 *   3. Price   — calculate and display live price
 *   4. Weight  — HideShip weight proxy (1g / 2g / 3g by length bracket)
 *   5. Validate — enforce min/max, show inline error
 *   6. Cart    — intercept add-to-cart, call duplicate.cfm, then /cart/add.js
 */

$(document).ready(function () {

  // ─────────────────────────────────────────────
  // 1. Helpers
  // ─────────────────────────────────────────────

  function formatPrice(amount) {
    // Swiss format: 1.234,50 → "CHF 1'234.50"
    return 'CHF ' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function roundOneDecimal(num) {
    return Math.round(num * 10) / 10;
  }

  // ─────────────────────────────────────────────
  // 2. Config
  // ─────────────────────────────────────────────

  var $container = $('[data-schiene-configurator]');

  // Bail out if no schiene configurator on this page
  if ($container.length === 0) return;

  var pricePerHundred = parseFloat($container.data('price-per-100cm'));
  var minLength       = parseInt($container.data('min-length'), 10);
  var maxLength       = parseInt($container.data('max-length'), 10);

  var $lengthInput    = $('#schiene-laenge');
  var $aufhaengeort   = $('#schiene-aufhaengeort');
  var $lengthError    = $('[data-schiene-length-error]');

  var $addToCart      = $('[data-add-to-cart-trigger]');

  // ─────────────────────────────────────────────
  // 3. Price
  // ─────────────────────────────────────────────

  function calcPrice(lengthCm) {
    return Math.round((lengthCm / 100) * pricePerHundred * 100) / 100;
  }

  function updatePriceDisplay(lengthCm) {
    var price = calcPrice(lengthCm);
    $('.purchase-details .price .money')
      .text(formatPrice(price))
      .attr('data-price', price);
  }

  function clearPriceDisplay() {
    $('.purchase-details .price .money')
      .text('–')
      .removeAttr('data-price');
  }

  // ─────────────────────────────────────────────
  // 4. Weight (HideShip weight proxy)
  // ─────────────────────────────────────────────

  // The weight value is set on the Shopify product duplicate via the API.
  // We pass it in productData so stotz.cfc can apply it via productSet.
  //   ≤ 250 cm → 1 g  → Sperrgut CHF 50.00
  //   ≤ 350 cm → 2 g  → Sperrgut CHF 90.00
  //   > 350 cm → 3 g  → Sperrgut CHF 150.00

  function calcWeightProxy(lengthCm) {
    if (lengthCm <= 250) return 1;
    if (lengthCm <= 350) return 2;
    return 3;
  }

  // ─────────────────────────────────────────────
  // 5. Validate
  // ─────────────────────────────────────────────

  function showError(msg) {
    $lengthError.text(msg).show();
    $addToCart.prop('disabled', true);
  }

  function clearError() {
    $lengthError.text('').hide();
    $addToCart.prop('disabled', false);
  }

  function validateLength(lengthCm) {
    if (isNaN(lengthCm) || lengthCm === '') {
      clearPriceDisplay();
      $addToCart.prop('disabled', true);
      return false;
    }
    if (lengthCm < minLength) {
      showError('Mindestlänge: ' + minLength + ' cm');
      clearPriceDisplay();
      return false;
    }
    if (lengthCm > maxLength) {
      showError('Maximallänge: ' + maxLength + ' cm');
      clearPriceDisplay();
      return false;
    }
    clearError();
    return true;
  }

  // ─────────────────────────────────────────────
  // Live price update on input
  // ─────────────────────────────────────────────

  // Button must be disabled on load — no length entered yet
  $addToCart.prop('disabled', true);

  $lengthInput.on('input change', function () {
    var raw = parseFloat($(this).val());
    var lengthCm = isNaN(raw) ? raw : roundOneDecimal(raw);
    if (validateLength(lengthCm)) {
      updatePriceDisplay(lengthCm);
    }
  });

  $lengthInput.on('blur', function () {
    var raw = parseFloat($(this).val());
    if (!isNaN(raw)) {
      $(this).val(roundOneDecimal(raw));
    }
  });

  // ─────────────────────────────────────────────
  // 6. Cart
  // ─────────────────────────────────────────────

  $addToCart.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($addToCart.hasClass('disabled')) return;

    var raw = parseFloat($lengthInput.val());
    var lengthCm = isNaN(raw) ? raw : roundOneDecimal(raw);
    if (!validateLength(lengthCm)) return;

    // Build the payload for duplicate.cfm
    var productData = {
      pid:                  $('[data-product-id]').data('product-id'),
      productType:          'schiene',
      price:                calcPrice(lengthCm),
      weight:               calcWeightProxy(lengthCm),
      title:                $('.vs-product-title').text().trim(),
      SchienLange:          lengthCm,
      original_product_url: window.location.href
    };

    var aufhaengeort = $.trim($aufhaengeort.val());
    if (aufhaengeort !== '') {
      productData.Aufhaengeort = aufhaengeort;
    }

    // Disable buttons while loading
    $addToCart.addClass('disabled button_loading');
    $('.fabric-sample > button').addClass('disabled');

    var shopDomain = window.PXUTheme.theme_settings.domain;

    $.ajax({
      type:        'POST',
      url:         'https://apps.vorhangschweiz.ch/functions/duplicate_schiene.cfm',
      data:        JSON.stringify(productData),
      contentType: 'application/json',
      dataType:    'json',
      headers:     { 'x-shopify-shop': shopDomain },

      success: function (data) {
        if (data.success !== true) {
          console.error('duplicate.cfm error', data);
          $addToCart.removeClass('disabled button_loading');
          return;
        }

        // Build Shopify line item properties (visible in order)
        var cartProperties = {
          'Schienenlänge':         lengthCm + ' cm',
          'Schienenbreite':        '1.6 cm',
          'Schienenhöhe':          '1.05 cm',
          'Abschlüsse':            'Im Preis inbegriffen',
          'Innenlauf':             'Für Maxi-Gleiter 6mm',
          '_original_product_url': productData.original_product_url
        };

        if (aufhaengeort !== '') {
          cartProperties['Aufhängeort'] = aufhaengeort;
        }

        // Read delivery time from page (same pattern as z__jsCalculator.js)
        var lieferzeitEl = $('[data-lieferzeit]');
        if (lieferzeitEl.length) {
          var lieferzeitVal = lieferzeitEl.text().trim();
          if (lieferzeitVal) {
            cartProperties['_Lieferzeit'] = lieferzeitVal;
          }
        }

        $.ajax({
          type:     'POST',
          url:      '/cart/add.js',
          dataType: 'json',
          data: {
            items: [{
              id:         data.vid,
              quantity:   parseInt($('.quantityPrice input.quantity-input.quantity-element').val()) || 1,
              properties: cartProperties
            }]
          },

          success: function () {
            $addToCart.removeClass('button_loading');
            $addToCart.find('svg.checkmark').addClass('checkmark-active');
            window.PXUTheme.jsAjaxCart.updateView();

            setTimeout(function () {
              $addToCart.find('i, span').hide();
            }, 300);

            setTimeout(function () {
              $('.header-cart.action-area__link').addClass('show-mini-cart');
              $addToCart.removeClass('disabled');
              $('.fabric-sample > button').removeClass('disabled');
              $addToCart.find('i, span').removeClass('zoomOut').show();
              $addToCart.find('svg.checkmark').removeClass('checkmark-active');
            }, 2000);
          },

          error: function (xhr) {
            console.error('/cart/add.js error', xhr);
            $addToCart.removeClass('disabled button_loading');
            $('.fabric-sample > button').removeClass('disabled');
          }
        });
      },

      error: function (xhr) {
        console.error('duplicate.cfm request failed', xhr);
        $addToCart.removeClass('disabled button_loading');
        $('.fabric-sample > button').removeClass('disabled');
      }
    });
  });

});
